<p-ai-chat-window-title-bar
    cdkDragHandle *ngIf="showTitleBar"
    [isDraggable]="isDraggable"
    [isAssistantWorking]="isAssistantWorking"
    [currentLayout]="currentLayout"
    [canvasAvailable]="canvasAvailable"
    (layoutChange)="layoutChange.emit($event)"
/>

<ng-content></ng-content>
